import { handleActions } from "redux-actions";

import { PAYMENTS_MANAGEMENT } from "constants/action-types";

interface IError {
    message: string;
    request: any;
    status: number;
    xhr: any;
}
export interface IState {
    result: any[];
    isFetching: boolean;
    error: boolean;
    errorObject: IError | undefined;
    status: "open" | "resolved";
}

const initialState = {
    result: [],
    isFetching: false,
    error: false,
    errorObject: undefined,
    status: "open" as "open", // until we know more, keeping this the only query filter vs a filters object
};

interface IResponse {
    payload?: string[];
    error?: boolean;
}

const chargebacksReducer = handleActions<IState, any>(
    {
        [PAYMENTS_MANAGEMENT.CHARGEBACKS.FETCH.START]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [PAYMENTS_MANAGEMENT.CHARGEBACKS.FETCH.COMPLETED]: (state: IState, { payload, error }): IState => {
            if (error) {
                return {
                    ...state,
                    result: [],
                    isFetching: false,
                    error: true,
                    errorObject: payload,
                };
            }
            return {
                ...state,
                result: payload,
                isFetching: false,
                error: undefined,
            };
        },
        [PAYMENTS_MANAGEMENT.CHARGEBACKS.FILTERCHANGE]: (state: IState, { payload }): IState => {
            return {
                ...state,
                status: payload.status,
                error: undefined,
            };
        },
        [PAYMENTS_MANAGEMENT.CHARGEBACK.FETCH.START]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
                error: undefined,
            };
        },
        [PAYMENTS_MANAGEMENT.CHARGEBACK.FETCH.COMPLETED]: (state: IState, { payload, error }: IResponse): IState => {
            return {
                ...state,
                result: payload,
                isFetching: false,
                error,
            };
        },
        [PAYMENTS_MANAGEMENT.CHARGEBACK.EVIDENCE.SUBMIT.START]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
                error: undefined,
            };
        },
        [PAYMENTS_MANAGEMENT.CHARGEBACK.EVIDENCE.SUBMIT.COMPLETED]: (
            state: IState,
            { payload, error }: IResponse,
        ): IState => {
            return {
                ...state,
                result: payload,
                isFetching: false,
                error,
            };
        },
    },
    initialState,
);

export default chargebacksReducer;
